import { Lightning } from '@lightningjs/sdk';
import { ScreenSize } from '../../api/ScreenSize';
import { Theme } from '../../config/theme';
import { SelectOptionList } from './SelectOptionList';

export class SelectOptionDialog extends Lightning.Component {
  static _template() {
    return {
      x: 0,
      y: 0,
      w: w => w,
      h: h => h,
      color: Theme.Colors.Option.Background.Page,
      rect: true,
      Options: {
        x: ScreenSize.w * 0.5,
        y: 0,
        mountX: 0.5,
        type: SelectOptionList,
      },
      Message: {
        x: w => w / 2,
        y: h => h / 2,
        mount: 0.5,
        visible: false,
        text: {
          ...Theme.Fonts.Normal,
          text: '',
        },
      },
    };
  }

  _init() {
    /**
     * @type {OptionList}
     */
    this.tag('Options').data = { title: this._params.title, options: this._params.options, callback: this._success };
  }

  set params(params) {
    this._params = params;
    this._success = params.onSuccess;
    this._cancelled = params.onCancelled;
    this.tag('Options').centerFocusedItem = params.centerFocusedItem;
    if (params.noContentMessage && this._params.options.length === 0) {
      this.tag('Message').visible = true;
      this.tag('Message').text.text = params.noContentMessage;
    } else {
      // should selectOptionDialog be reused, reset visibility
      this.tag('Message').visible = false;
      this.tag('Message').text.text = '';
    }
  }

  _getFocused() {
    return this.tag('Options');
  }

  _handleBack() {
    this._cancelled && this._cancelled();
    this.fireAncestors('$closeDialog');
  }
}
